import React from 'react';
import {Row, Col, Card} from "react-bootstrap";
import {Link} from "react-router-dom";
import {Event, BRAND} from "../../../../Helper";

export default class Footer extends React.Component {
    
    userAgreement = () => {
        Event.emit('show_agreement');
    }

    privacyPolicy = () => {
        Event.emit('show_privacy');
    }

    verify = () => {
        Event.emit('show_verify');
    }

    render(){
        const { t } = this.props;
        return(
            <>
                <footer className="bgame-footer font-light bg-footer ">
                    <div className='row footer-card m-0 p-0 mt-1 text-lightt justify-content-center'>


                            <div className='col-md-8 mb-2'>
                                <div className='text-center'>
                                    

                                    licensed by BCLB (Betting Control and Licensing Board of Kenya) under the Betting,
                                    Lotteries and Gaming Act, Cap 131, Laws of Kenya. BCLB No. BK0000687  <br></br>
                                    Must be 18 years of age or older to register or play at . Play responsibly.<br></br>
                                    <a href='tel:0723402156'> Call/Whatsapp 0723 402 156 </a> | <a
                                    href='https://www.facebook.com/people///'
                                    target='_blank'> Facebook </a> | <a
                                    href='https://www.instagram.com//'
                                    target='_blank'> Instagram </a> | <Link to={'/faqs'}>
                                        <span className={"text-light "}>
                                            FAQs
                                        </span>
                                </Link>
                                </div>
                            </div>

                        </div>
                </footer>
            </>
        );
    }
}